export default {
  sidebar: {
    switchSide: 'Switch side',
    showSidebar: 'Show sidebar',
    hideSidebar: 'Hide sidebar'
  }
}
